import { IDeserialize } from "./abstraction/IDeserialize";
import { ReminderInterval, ReminderType } from "./Enums";

export class Reminder implements IDeserialize<Reminder> {
  id: number;
  userId: number;
  companyName: string;
  prevRemind: Date;
  nextRemind: Date;
  pending?: boolean;

  // For admin view
  companyFullName?: string;
  countryCode?: string;
  countryName?: string;

  // Client only properties
  get daysBefore(): number | null {
    return [ReminderType.Calibration, ReminderType.Service].includes(this.type)
      ? this.daysInAdvance
      : null;
  }
  get daysAfter(): number | null {
    return this.type === ReminderType.PO ? this.daysInAdvance : null;
  }

  constructor(
    public companyId?: string,
    public type?: ReminderType,
    public interval?: ReminderInterval,
    public daysInAdvance: number = 0,
    public to?: string,
    public cc?: string,
    public bcc?: string,
  ) {}
  deserialize(dto: Reminder): Reminder {
    Object.assign(this, dto);
    return this;
  }
}
